<template>
  <div>
    <gj-table
        :adapt-height="false"
        :index="false"
        :height="360"
        :show-overflow="false"
        :columns="tableColumns"
        :data="tableData"
    >
      <template v-slot:productInfo="{row}">
        <div>{{row.productName}}</div>
        <div>{{row.sku}}</div>
        <div>{{row.categoryName	}}</div>
      </template>
      <template v-slot:msku="{row}">
        <div>{{row.msku}}</div>
        <div>{{row.fnsku}}</div>
        <div>{{row.asin}}</div>
      </template>
      <template v-for="(col, rowIndex) in dynamicCol" v-slot:[col.key]="{row}">
        <div :key="rowIndex">
          {{col.currencySymbol}}{{row[col.key]}}
        </div>
      </template>
      <template v-for="(col, rowIndex) in dynamicTotalCol" v-slot:[col.totalKey]="{row}">
        <div :key="rowIndex">
          {{col.currencySymbol}}{{calcFeeTotal(row, col.key)}}
        </div>
      </template>
      <template #footer>
        <div class="default" v-gutter="20">
          <div>
            <span>商品种类数：</span>
            <span>{{tableData.length}}</span>
          </div>
          <div>
            <span>发货量合计：</span>
            <span>{{getShipmentTotal()}}</span>
          </div>
          <template v-for="(col, index) in dynamicCol">
            <div :key="index">
              <span>{{col.feeTypeName}}合计：</span>
              <span>{{col.currencySymbol}}{{buildFeeTypeTotal(col.key)}}</span>
            </div>
          </template>
        </div>
      </template>
    </gj-table>
  </div>
</template>

<script>
  import {isMeaningful, isMeaningless} from "../../../../../utils/common";
  import { amount } from "@/filters"

  export default {
    name: "app-shipment-bill-share-detail",
    props: {
      logisticsFeeList: null,
    },
    watch: {
      logisticsFeeList: {
        immediate: true,
        handler(value) {
          if (isMeaningful(value)) {
            this.buildCol(value);
          }
        }
      }
    },
    data() {
      return {
        columns: [
          {id: 'warehouseName', header: '目的仓', field: 'warehouseName', width: '100px'},
          {id: 'warehouseCode', header: '配送地址', field: 'sku', minWidth: '80px'},
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', minWidth: '50px'},
          {id: 'marketId', header: '国家/店铺', field: 'option:marketId', minWidth: '120px', options: () => this.marketOption},
          {id: 'productInfo', header: '产品名称/SKU/产品类型-品类', field: 'slot:productInfo', minWidth: '190px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '160px'},
          {id: 'singleWeight', header: '单品实重(g)', field: 'singleWeight', minWidth: '100px'},
          {id: 'volume', header: '单品体积(CBM)', field: 'volume', minWidth: '120px'},
          {id: 'singleVolumeWeight', header: '单品体积重(KG)', field: 'singleVolumeWeight', minWidth: '120px'},
          {id: 'singleApplyPrice', header: '单品申报单价', field: 'singleApplyPrice', minWidth: '100px'},
          {id: 'quantity', header: '发货量', field: 'quantity', minWidth: '80px'},
        ],
        tableColumns: [],
        dynamicCol: [],
        dynamicTotalCol: [],
        tableData: [],
      }
    },
    methods: {
      getShipmentTotal() {
        let sum = 0;
        this.tableData.forEach(v => sum += Number(v.quantity || 0));
        return sum;
      },
      buildCol(data) {
        const cols = [];
        if (data.length !== 0) {
          this.dynamicCol = data[0].logisticsFeeItemList;
          this.dynamicTotalCol = data[0].logisticsFeeItemList.map(v => {
            return {
              key: v.key,
              totalKey: v.key + 'Total',
              currencySymbol: v.currencySymbol,
            }
          });
          for (let i = 0; i< data.length; i++) {
            data[i].logisticsFeeItemList.forEach(v => {
              data[i][v.key] = v.fee;
              if (i === 0) {
                cols.push({id: v.key, header: v.feeTypeName + '分摊单价', field: `slot:${v.key}`, minWidth: '100px'});
                cols.push({id: v.key+'Total', header: v.feeTypeName + '总价', field: `slot:${v.key}Total`, minWidth: '80px', align: 'right'});
              }
            })
          }
        } else {
          this.dynamicCol = [];
        }
        this.tableData = data;
        this.tableColumns = this.columns.concat(cols);
      },
      calcFeeTotal(row, key) {
        if (isMeaningless(row[key]) || isMeaningless(row.quantity) || isNaN(row[key]) || isNaN(row.quantity)) {
          return 0;
        }
        return Number(row[key]) * Number(row.quantity);
      },
      buildFeeTypeTotal(key) {
        let total = 0;
        for (let i = 0; i < this.tableData.length; i++) {
          total += this.calcFeeTotal(this.tableData[i], key);
        }
        total = amount(total)
        return total;
      }
    }
  }
</script>

<style scoped>

</style>
